import { useRef, useEffect } from 'react';

function useChatScroll() {
  const element = useRef<HTMLDivElement>();
  useEffect(() => {
    if (element.current) {
      element.current.scrollTop = element.current.scrollHeight;
    }
  });
  return element;
}

export default useChatScroll;
